import { v2Colors, breakpoints } from '@web-for-marketing/react-ui';

export const tagPageStyles = {
    mainTitle: {
        width: '100%',
        display: 'inline-block',
        marginBottom: '2rem',
    },
    labelContainer: {
        display: 'flex',
        padding: 0,
        marginLeft: '2%',
        '& > *': {
            marginLeft: 0,
            marginRight: 0,
        },
        '& > div > div': {
            border: 'none',
        },
        [`@media (max-width: ${breakpoints.md})`]: {
            margin: 0,
            width: '50%',
        },
    },
    cardContainer: {
        marginTop: '2rem',
        [`@media (max-width: ${breakpoints.md})`]: {
            marginTop: '2rem',
        },
    },
    filterContainer: {
        flexWrap: 'nowrap',
        justifyContent: 'flex-end',
        marginTop: '1rem',
        '& > div > div > div': {
            background: 'none',
        },
        '& > div > div > div:hover': {
            background: v2Colors.core.smoke,
        },
        [`@media (max-width: ${breakpoints.md})`]: {
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
        },
    },
    pagination: {
        width: '100%',
        marginTop: '2rem',
    },
    headerBackground: {
        position: 'relative',
        zIndex: 1,
        '&:after': {
            content: '""',
            position: 'absolute',
            height: '100%',
            maxHeight: '50rem',
            width: '100%',
            top: 0,
            left: 0,
            backgroundColor: v2Colors.core.cloud,
            zIndex: -1,
        },
    },
    filterPageContainer: {
        display: 'flex',
        flexWrap: 'nowrap',
        [`@media (max-width: ${breakpoints.md})`]: {
            flexWrap: 'wrap',
        },
    },
} as const;
